import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=29bbceea&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=29bbceea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbceea",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Layout/DashboardLayout.vue
// module id = 39
// module chunks = 31